module.exports = __webpack_public_path__ + "files/SPIADI2024 - Rapport annuel d'activité.0fcda9ca2570493bcaf8d081bdf9f543.pdf";